import script from "./MobileTaxRefund.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileTaxRefund.vue?vue&type=script&setup=true&lang=ts"

import "./MobileTaxRefund.vue?vue&type=style&index=0&id=6cc20350&scoped=true&lang=css"

import exportComponent from "/var/www/jobployee-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cc20350"]])

export default __exports__